import { useContext, useCallback } from 'react';
import _get from 'lodash/get';

import { AuthContext } from 'context/AuthContext';
import useEcomPlatform from './useEcomPlatform';
import { RETURN_MODES } from 'dictionary/returnsMode';

/**
 * @returns {{
 *  storeProperties: Object,
 *  getStoreProperty: (key: string, defaultValue?: any) => any,
 *  isSSRStore: boolean,
 *  services: Array<'returns' | 'exchanges'>
 * }}
 */
export default function useStore() {
  const { storeProperties } = useContext(AuthContext);
  const { checkIfPlatformIs } = useEcomPlatform();

  const getStoreProperty = useCallback(
    (key, defaultValue) => _get(storeProperties, key, defaultValue),
    [storeProperties],
  );

  const ssSellerId = getStoreProperty('ss_seller_id');
  const isSSRStore = getStoreProperty('is_ssr_retailer', false);
  const storeUniqueName = getStoreProperty('store_unique_name');
  const isAdvancedMode = !checkIfPlatformIs('SS_GENERIC_ECOM');

  const prefix = isSSRStore ? 'SSR' : 'RR';
  const brand = isSSRStore ? 'ShipStation Returns' : 'Return Rabbit';
  const merchantId = !!storeUniqueName ? `${prefix}-${storeUniqueName}` : null;
  const returnsMode = isAdvancedMode
    ? RETURN_MODES.ADVANCED
    : RETURN_MODES.BASIC;

  const isExchangeAllowed = getStoreProperty('is_exchange_allowed', false);
  const services = ['returns'];
  if (isExchangeAllowed) services.push('exchanges');

  return {
    brand,
    isSSRStore,
    ssSellerId,
    merchantId,
    returnsMode,
    isAdvancedMode,
    storeProperties,
    getStoreProperty,
    services,
  };
}
